import ParagraphFooterRow from 'src/components/paragraphs/ParagraphFooterRow';
import ParagraphLinkedLogo from 'src/components/paragraphs/ParagraphLinkedLogo';
import ParagraphMenu from 'src/components/paragraphs/ParagraphMenu';
import ParagraphNavigation from 'src/components/paragraphs/ParagraphNavigation';
import ParagraphSearchForm from 'src/components/paragraphs/ParagraphSearchForm';
import ParagraphSocialLinks from 'src/components/paragraphs/ParagraphSocialLinks';
import ParagraphText from 'src/components/paragraphs/ParagraphText';

const paragraphComponents = {
  paragraph__navigation: ParagraphNavigation,
  paragraph__search_form: ParagraphSearchForm,
  paragraph__menu: ParagraphMenu,
  paragraph__linked_logo: ParagraphLinkedLogo,
  paragraph__social_links: ParagraphSocialLinks,
  paragraph__footer_row: ParagraphFooterRow,
  paragraph__text: ParagraphText,
};

export type ParagraphComponentType = keyof typeof paragraphComponents;

export default paragraphComponents;
